/** @jsxImportSource @emotion/react */
import type { Interpolation } from "@emotion/react";
import {
  numericViewportHeight,
  numericViewportWidth,
  spacing,
  zIndices,
} from "@packages/ui/emotion";
import type { EventHandler } from "react";
import { forwardRef } from "react";

type GameFrameProps = {
  onLoad?: EventHandler<any>;
  src: string;
};

const iframeStyle: Interpolation = {
  border: spacing.none,
  bottom: spacing.none,
  height: numericViewportHeight[100],
  left: spacing.none,
  outline: "none",
  position: "fixed",
  right: spacing.none,
  top: spacing.none,
  width: numericViewportWidth[100],
  zIndex: zIndices.games,
};

export const GameFrame = forwardRef<HTMLIFrameElement, GameFrameProps>(
  ({ onLoad, src }, ref) => (
    <iframe ref={ref} onLoad={onLoad} src={src} css={iframeStyle} />
  ),
);

GameFrame.displayName = "GameFrame";
